// Mini-campo táctil para elegir la posición en la que jugó el niño/a.
export const POSITIONS = [
  { key: "POR", label: "Portero", x: 50, y: 88 },
  { key: "LI", label: "Lateral izq.", x: 16, y: 70 },
  { key: "CT", label: "Central", x: 50, y: 72 },
  { key: "LD", label: "Lateral der.", x: 84, y: 70 },
  { key: "MCD", label: "Pivote", x: 50, y: 56 },
  { key: "MC", label: "Mediocentro", x: 50, y: 42 },
  { key: "EI", label: "Extremo izq.", x: 14, y: 28 },
  { key: "MP", label: "Mediapunta", x: 50, y: 28 },
  { key: "ED", label: "Extremo der.", x: 86, y: 28 },
  { key: "DEL", label: "Delantero", x: 50, y: 12 },
];

export const POSITION_LABEL = Object.fromEntries(POSITIONS.map((p) => [p.key, p.label]));

export function PositionPicker({ value, onChange, testId = "position-picker" }) {
  return (
    <div>
      <div className="relative w-full max-w-[220px] mx-auto select-none"
        data-testid={testId}
        style={{ aspectRatio: "3/4", backgroundColor: "#0f6127", backgroundImage: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(0,0,0,0.12))", border: "2px solid rgba(255,255,255,0.45)" }}>
        <div className="absolute left-0 right-0 top-1/2 h-[1.5px] bg-white/40" />
        <div className="absolute left-1/2 top-1/2 w-[24%] aspect-square -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/40" />
        <div className="absolute left-1/2 bottom-0 w-[52%] h-[13%] -translate-x-1/2 border border-b-0 border-white/40" />
        <div className="absolute left-1/2 top-0 w-[52%] h-[13%] -translate-x-1/2 border border-t-0 border-white/40" />
        {POSITIONS.map((p) => {
          const sel = value === p.key;
          return (
            <button key={p.key} type="button" data-testid={`${testId}-${p.key}`}
              onClick={() => onChange(sel ? null : p.key)}
              title={p.label}
              className={`absolute -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full text-[9px] font-black flex items-center justify-center transition-transform ${sel ? "bg-red-600 text-white scale-125 ring-2 ring-white" : "bg-black/40 text-white/80 border border-white/40 hover:bg-black/60"}`}
              style={{ left: `${p.x}%`, top: `${p.y}%` }}>
              {p.key}
            </button>
          );
        })}
      </div>
      <div className="text-center text-[10px] font-mono mt-1 text-muted-foreground" data-testid={`${testId}-label`}>
        {value ? <span className="text-primary font-bold">📍 {POSITION_LABEL[value]}</span> : "Toca dónde jugó (opcional)"}
      </div>
    </div>
  );
}
